export default __webpack_public_path__ + "static/media/4.9573c075.png";